import {Component} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {toSignal} from '@angular/core/rxjs-interop';
import {DirectusTooltipComponent} from '../../../../../../../shared/components/directus-tooltip/directus-tooltip.component';
import {ProjectStepSaveButtonComponent} from '../../../../../../../shared/project-step-save-button/project-step-save-button.component';
import {AbstractFormDirective, FormControlsConfig} from '../components/abstract-form-directive';
import {ContractParametersResponse} from '@frontend/shared';
import {FormFieldNumberComponent} from '../../../../../../../shared/components/inputs/form-field/form-field-number/form-field-number.component';
import {FormFieldSelectButtonComponent} from '../../../../../../../shared/components/inputs/form-field/form-field-submit-button/form-field-select-button.component';

@Component({
  selector: 'app-contract-parameters',
  imports: [
    DirectusTooltipComponent,
    FormsModule,
    ProjectStepSaveButtonComponent,
    ReactiveFormsModule,
    FormFieldNumberComponent,
    TranslocoPipe,
    FormFieldSelectButtonComponent,
  ],
  templateUrl: './contract-parameters.component.html',
})
export class ContractParametersComponent extends AbstractFormDirective<ContractParametersResponse> {
  private static readonly FORM_CONTROLS: FormControlsConfig<ContractParametersResponse> = {
    contractTotalTerms: [
      null,
      {validators: [Validators.required, Validators.min(1), Validators.max(10)]},
    ],
    solutionType: [null],
    implementationMethod: [null],
    terminationPeriod: [
      null,
      {validators: [Validators.required, Validators.min(1), Validators.max(10)]},
    ],
    licenseModel: [null],
    paymentTerm: [null],
  };

  // ---- signals -------
  readonly solutionTypeOptions = toSignal(
    this.directusService.loadDirectusDropdown('rfq_parameter_solution_type'),
    {
      initialValue: [],
    },
  );
  readonly implementationMethodOptions = toSignal(
    this.directusService.loadDirectusDropdown('rfq_parameter_implementation_method'),
    {
      initialValue: [],
    },
  );
  readonly licenseModelOptions = toSignal(
    this.directusService.loadDirectusDropdown('rfq_parameter_license_model'),
    {
      initialValue: [],
    },
  );
  readonly paymentTermOptions = toSignal(
    this.directusService.loadDirectusDropdown('rfq_parameter_payment_term'),
    {
      initialValue: [],
    },
  );

  constructor() {
    super(ContractParametersComponent.FORM_CONTROLS);
  }
}
